<template>
  <BaseDialog :is-open="isOpen" @close="emits('closeDialog')" type="basic" :title="title">
    <div class="flex flex-col gap-0.5">
      <SelectableSurveyItem
        v-for="survey in allSurveys"
        class="last:rounded-b-large first:rounded-t-large"
        :key="survey.id"
        :survey="survey"
        :topic-perspectives="topicPerspectives"
        :is-selected="isSelected(survey.id)"
        :subject="subject"
        @click="toggleSurvey(survey.id)"
      />
    </div>
    <template #confirm>
      <BaseTextButton :disabled="currentlySelectedSurveyIds.length == 0" @click="selectSurveys"
        >Anwenden</BaseTextButton
      >
    </template>
    <template #dismiss>
      <BaseTextButton color="text" @click="emits('closeDialog')">Abbrechen</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import SelectableSurveyItem from './SelectableSurveyItem.vue'
  import { ref } from 'vue'
  import type { SurveySelectionPreview } from '@/modules/profile/composables/use-evaluation-profile'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import type { Perspective } from '@/core/models/perspective'

  interface Props {
    title: string
    isOpen: boolean
    subject: MemberOrUser
    allSurveys: ReadonlyArray<SurveySelectionPreview>
    topicPerspectives?: ReadonlyArray<Perspective>
  }

  const props = defineProps<Props>()

  const selectedSurveyIds = defineModel<string[]>({ required: true })

  const currentlySelectedSurveyIds = ref(props.allSurveys.map((survey) => survey.id))

  const emits = defineEmits<{
    (e: 'closeDialog'): void
  }>()

  const toggleSurvey = (surveyId: string) => {
    if (currentlySelectedSurveyIds.value.includes(surveyId)) {
      currentlySelectedSurveyIds.value = currentlySelectedSurveyIds.value.filter(
        (id) => id !== surveyId,
      )
    } else {
      currentlySelectedSurveyIds.value.push(surveyId)
    }
  }

  const isSelected = (surveyId: string) => {
    return currentlySelectedSurveyIds.value.includes(surveyId)
  }

  const selectSurveys = () => {
    selectedSurveyIds.value = currentlySelectedSurveyIds.value
    emits('closeDialog')
  }
</script>
